export default {"src":"/_next/static/media/hockey.0f2b69bf.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};